<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VRadioWithBlockLabel from "../../Form/Survey/VRadioWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import intus from "@/Plugins/intus";
import { isRequired } from "intus/rules";

import { scrollOnError } from "@/Helpers/validation";

const props = defineProps({
    additional: Object,
    isShowSubmit: {
        Type: Boolean,
        default: true,
    },
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    which_of_the_following_entry_point_did_you_go_through_to_enter_sabah:
        answers?.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah,
});

form.setError(props.additional.errors);

const emits = defineEmits("onNext");

const handleClickNext = () => {
    const validation = intus.validate(
        form.data(),
        {
            which_of_the_following_entry_point_did_you_go_through_to_enter_sabah:
                [isRequired()],
        },
        {
            ...intus.messages,
            which_of_the_following_entry_point_did_you_go_through_to_enter_sabah:
                surveyFields[
                    "which_of_the_following_entry_point_did_you_go_through_to_enter_sabah"
                ]?.name,
        }
    );

    form.clearErrors();
    if (validation.passes()) {
        emits("onNext", form.data());
    } else {
        form.setError(validation.errors());
        setTimeout(() => scrollOnError(), 300);
    }
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VRadioWithBlockLabel
                        elId="which_of_the_following_entry_point_did_you_go_through_to_enter_sabah"
                        v-model:value="
                            form.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
                        "
                        :label="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_enter_sabah'
                            ]?.name
                        "
                        :options="
                            surveyFields[
                                'which_of_the_following_entry_point_did_you_go_through_to_enter_sabah'
                            ]?.options.map((value) => {
                                return { id: value, description: value };
                            })
                        "
                        :error="
                            form.errors
                                ?.which_of_the_following_entry_point_did_you_go_through_to_enter_sabah
                        "
                    />
                </div>
            </div>
        </div>
        <VDevider />

        <div class="text-end" v-if="isShowSubmit">
            <VButtonSubmit type="button" @onCLickSubmit="handleClickNext">
                {{ $t("public.page.survey.button.next") }}
            </VButtonSubmit>
        </div>
    </div>
</template>
